import TransferListing from "./transferListing.container";

export default TransferListing;
